export const LOAD_OUTBOUNDDATA_LOADING = 'REDUX_SAGA_LOAD_OUTBOUNDDATA_LOADING';
export const LOAD_OUTBOUNDDATA_SUCCESS = 'REDUX_SAGA_LOAD_OUTBOUNDDATA_SUCCESS';
export const LOAD_OUTBOUNDDATA_ERROR = 'REDUX_SAGA_LOAD_OUTBOUNDDATA_ERROR';

export const loadExceptions = () => dispatch => {
    dispatch({ type: LOAD_OUTBOUNDDATA_LOADING });
};